import { useSelector } from 'react-redux';

import { currentRoleSelector } from 'store/modules/auth';

export const useCurrentRole = () => {
  const role = useSelector(currentRoleSelector);
  return role;
};
